
export const homeLocal = {
    en:{
        title:'title',
    },
    fr:{
        title:'titre',
    }
} 